
export const NAME_REDUCER = 'customer';

export const PREFIX_ACTIONS = 'customer_feature_';


export const PATH_LOADING = {
  getData: `loading.${NAME_REDUCER}.getData`,
};
